module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HNn9nM/tc-custom/9781685624651.jpg?1705056345810",
      "alt": "This image is the cover for the book The Unique Friendship of Grover and Steve"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Unique Friendship of Grover and Steve\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("On the Great Plains, we find Grover, a donkey and Steve, an ostrich, who are the best of friends despite their differences.")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("The other animals on the plains just cannot understand how they are even friends. Donkeys and ostriches are just too different!")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("For Grover and Steve, while there are many differences between the two, what's most important to them is the bond of friendship.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lee Cherry, Buffie Biddle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Author:")])])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Lee Cherry is the author of "), _c('em', [_vm._v("The Unique Friendship of Grover and Steve")]), _vm._v(", his first book. He wanted to create a children’s book with the message that regardless of our differences, we can all be friends, and do so in a way that children would understand. Lee attended the University of Central Florida and graduated with a degree in Business Administration. He resides in Florida with his wife and three children.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Illustrator: ")])])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Barbara “Buffie” Biddle is the illustrator of "), _c('em', [_vm._v("The Unique "), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_c('em', [_vm._v("Friendship")])]), _vm._v(" of Grover and Steve")]), _vm._v(". She is both an author and illustrator of a variety of children’s books. From an early age, Buffie loved drawing, painting, and making up stories and telling tales. Buffie attended Moore College of Art and Design and graduated from West Chester University with a degree in Fine Art and a minor in Special Education. Buffie resides in Pennsylvania with her family. ")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0